import { AutogenLayoutOrderPayablesProfileFilter } from "./autogen/AutogenLayoutOrderPayablesProfileFilter";

export class OrderPayablesProfileFilter extends AutogenLayoutOrderPayablesProfileFilter {
    onLoad(): void | Promise<void> {
        this.layoutProfile.textboxDescr.enabled = false;
        this.layoutProfile.layoutProfileColor.visible = false;
        this.sourceOrderPayablesProfile.addAfterModeChangeListener(() => {
           this.layoutProfile.textboxInterfaceTransactionNum.visible = this.activeRow?.getBoolean("triumphpay_active", false);
        });
    }
}
